import "./header.css";

//import(/* webpackPrefetch: true */ './header-dropdowns.js');
import './header-dropdowns.js';


$(function () {
    const $nav = $('.sub-navigation nav');
    let scrollInterval;

    if ((document.documentElement.clientWidth > 1308) && ($nav[0].scrollWidth > $nav.innerWidth())) {
        $('.sub-navigation .scroll-arrow.right').removeClass('hidden');
    }

    function startScroll(direction) {
        //console.log('head startScrollstartScrollstartScrollstartScrollstartScroll');
        const speed = 10; // px per interval
        scrollInterval = setInterval(() => {
            $nav.scrollLeft($nav.scrollLeft() + (direction === 'left' ? -speed : speed));
        }, 16); // ~60fps
        $('.sub-navigation .scroll-arrow.left').removeClass('hidden');
    }

    function stopScroll() {
        clearInterval(scrollInterval);
    }

    $('.scroll-arrow.left').hover(
        () => startScroll('left'),
        stopScroll
    );

    $('.scroll-arrow.right').hover(
        () => startScroll('right'),
        stopScroll
    );
    
    
    let lastScroll = $(document).scrollTop();
    let headerHeight = $('.site-header').outerHeight();
    let lastActionScroll = 0;

    $(window).on('scroll', function () {
        const currentScroll = $(document).scrollTop();

        if (currentScroll > headerHeight) {
            if (Math.abs(currentScroll - lastActionScroll) > 100) {
                if (currentScroll > lastScroll) {
                    $('.site-header')
                            .removeClass('showHeader')
                            .addClass('hideHeader');
                } else {
                    $('.site-header')
                            .removeClass('hideHeader')
                            .addClass('showHeader');
                }
                lastActionScroll = currentScroll;
            }
        } else {
            $('.site-header')
                    .removeClass('hideHeader')
                    .addClass('showHeader');
        }

        lastScroll = currentScroll;
    });

    
    
});